import { useEffect, useState } from 'react';
import {
	allowScroll,
	changeDeliveryCompany,
	changePrice,
	parseMarketOrderStatus,
	parseVendorOrderStatus,
	parseNumber,
	preventScroll,
} from '../../common/utils';
import DaumPostcode from 'react-daum-postcode';
import axios from 'axios';
import resetIcon from '../../../img/resetIcon.png';

function OrderInfoModal(props) {
	const [OrderData, setOrderData] = useState({});
	const [IsGetAddressOpen, setIsGetAddressOpen] = useState(false);
	const handleInputChange = (e, type) => {
		const updatedData = { ...OrderData };
		updatedData[type] = e.target.value;

		setOrderData(updatedData);
	};
	const reset = (e) => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm('도매사 주문상태를 발주대기 상태로 변경하시겠습니까?');
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			axios({
				method: 'POST',
				url: `${window.location.protocol}//${window.location.hostname}:3001/resetOrder`,
				data: {
					token: localStorage.getItem('token'),
					config: {
						orderId: OrderData.orderId,
					},
				},
				xhrFields: {
					withCredentials: true,
				},
			}).then((res) => {
				const updatedData = { ...OrderData };
				updatedData.vendorOrderStatus = 'ORDER_WAITING';
				setOrderData(updatedData);
			})
		}
	};
	const handleModify = (type) => {
		if (type === 'address') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('주소를 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				changeOrder({
					idx: OrderData.idx,
					target: type,
					value: {
						baseAddress: OrderData.baseAddress,
						detailedAddress: OrderData.detailedAddress,
						zipCode: OrderData.zipCode,
					},
				});
			} else {
				console.log(`${type} 저장 취소`);
			}
		} else if (type === 'shippingMemo') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('배송메시지를 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				changeOrder({
					idx: OrderData.idx,
					target: type,
					value: OrderData.shippingMemo,
				});
			} else {
				console.log(`${type} 저장 취소`);
			}
		}
	};
	const changeOrder = (config) => {
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/changeOrder`,
			data: {
				token: localStorage.getItem('token'),
				config,
			},
			xhrFields: {
				withCredentials: true,
			},
		});
	};
	const handleAddress = (value) => {
		if (value) {
			setIsGetAddressOpen(value);
		} else {
			setIsGetAddressOpen(!IsGetAddressOpen);
		}
	};
	const handleComplete = (data) => {
		let fullAddress = data.address;
		let extraAddress = '';
		let zipCode = data.zonecode;
		// 기본 주소가 도로명 타입일때 조합한다.
		if (data.addressType === 'R') {
			//법정동명이 있을 경우 추가한다.
			if (data.bname !== '') {
				extraAddress += data.bname;
			}
			// 건물명이 있을 경우 추가한다.
			if (data.buildingName !== '') {
				extraAddress +=
					extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
			}
			// 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
			fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
		}
		handleAddressInputChange(fullAddress, zipCode);
		setIsGetAddressOpen(false);
	};
	const handleAddressInputChange = (fullAddress, zipCode) => {
		const updatedData = { ...OrderData };
		if (fullAddress) {
			updatedData.baseAddress = fullAddress;
			updatedData.zipCode = zipCode;
		}
		setOrderData(updatedData);
	};
	const daumPostAPI = {
		position: 'fixed',
		left: '50%',
		top: '50%',
		width: '80%',
		height: '80%',
		transform: 'translate(-50%, -50%)',
		borderRadius: '10px',
		zIndex: 3,
	};
	useEffect(() => {
		setOrderData(props.data);
		const prevScrollY = preventScroll();
		return () => {
			allowScroll(prevScrollY); //컴포넌트가 언마운트되거나 업데이트될 때 이 함수가 실행
		};
	}, []);

	return (
		<div className='modal'>
			<div
				className='overlay'
				onClick={() => props.getOrderInfoModalOpen(false)}
			></div>
			<div className='modal-content'>
				<div className='modal-header'>
					<h2>
						{OrderData.orderId}_{OrderData.productOrderId}
					</h2>
					<p>(주문번호_상품주문번호)</p>
				</div>
				<button
					className='close-modal'
					onClick={() => props.getOrderInfoModalOpen(false)}
				></button>
				<div
					className='modal-body'
					style={!IsGetAddressOpen ? {} : { overflowY: 'hidden' }}
				>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>마켓</span>
							<span className='value'>{OrderData.marketCode}</span>
						</div>
						<div className='modal-column'>
							<span className='key'>아이디</span>
							<span className='value'>{OrderData.marketID}</span>
						</div>
					</div>
					<div className='modal-column'>
						<span className='key'>도매사주문번호</span>
						<span className='value'>{OrderData.vendorOrderId}</span>
					</div>
					<div className='modal-column'>
						<span className='key'>송장정보</span>
						<span className='value values'>
							<span>{changeDeliveryCompany(OrderData.deliveryCompany)}</span>
							<span>{OrderData.trackingNumber}</span>
						</span>
					</div>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>마켓주문상태</span>
							<span className='value'>
								{parseMarketOrderStatus(OrderData.marketOrderStatus)}
							</span>
						</div>
						<div className='modal-column'>
							<span className='key'>도매사주문상태</span>
							<span className='value resetButton'>
								<span>
									{parseVendorOrderStatus(OrderData.vendorOrderStatus)}
								</span>
								{OrderData.vendorOrderStatus === 'ERROR' && (
									<button
										type='reset'
										onClick={reset}
										className='resetIconButton'
									>
										<span>
											<img src={resetIcon} alt='resetIcon' />
										</span>
										{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
									</button>
								)}
							</span>
						</div>
					</div>
					<div className='modal-column'>
						<span className='key'>주문일시</span>
						<span className='value'>
							<span>{OrderData.paymentDate}</span>
						</span>
					</div>
					<div className='modal-column'>
						<span className='key'>상품관리코드</span>
						<span className='value'>
							<span>{OrderData.manageCode}</span>
						</span>
					</div>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>상품명</span>
							<span className='value'>{OrderData.productName}</span>
						</div>
						<div className='modal-column'>
							<span className='key'>옵션정보</span>
							<span className='value'>
								<span>{OrderData.productOption || ''}</span>
							</span>
						</div>
					</div>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>결제금액</span>
							<span className='value'>
								<span>{changePrice(OrderData.totalPaymentAmount)}</span>
							</span>
						</div>
						<div className='modal-column'>
							<span className='key'>주문수량</span>
							<span className='value'>{OrderData.quantity}</span>
						</div>
					</div>
					<div className='modal-column'>
						<span className='key'>배송비총액</span>
						<span className='value'>{(changePrice(OrderData.deliveryFeeAmount))}</span>
					</div>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>정산예정금액 (주문건별 배송비제외)</span>
							<span className='value'>{(OrderData.expectedSettlementAmount && changePrice(OrderData.expectedSettlementAmount)) || '알수없음'}</span>
						</div>
						<div className='modal-column'>
							<span className='key'>발주총액</span>
							<span className='value'>{(OrderData.orderAmount && changePrice(OrderData.orderAmount)) || '알수없음'}</span>
						</div>
					</div>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>주문자명</span>
							<span className='value'>{OrderData.ordererName}</span>
						</div>
						<div className='modal-column'>
							<span className='key'>주문자 연락처</span>
							<span className='value'>
								<span> {parseNumber(OrderData.ordererTel)}</span>
							</span>
						</div>
					</div>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>수취인명</span>
							<span className='value'>{OrderData.receiverName}</span>
						</div>
						<div className='modal-column'>
							<span className='key'>수취인 연락처</span>
							<span className='value'>
								<span>{parseNumber(OrderData.receiverTel1 || OrderData.receiverTel2)}</span>
							</span>
						</div>
					</div>
					<div className='modal-column' style={{ marginBottom: '0' }}>
						<span className='key'>수취인 주소</span>
						<div className='modal-column-row'>
							<span className='key noindent'>우편번호</span>
							{/* <span className='value'>{OrderData.zipCode}</span> */}
							<span className='value'>
								<input
									type='text'
									value={OrderData.zipCode}
									onChange={(e) => handleInputChange(e, 'zipCode')}
								/>
							</span>
							<button onClick={() => handleAddress(true)} className='address'>
								우편번호 찾기
							</button>
							{IsGetAddressOpen && (
								<div
									className='addressOverlay'
									style={
										IsGetAddressOpen
											? { display: 'block', cursor: 'pointer' }
											: { display: 'none' }
									}
									onClick={() => handleAddress(false)}
								>
									<DaumPostcode
										onComplete={handleComplete}
										style={daumPostAPI}
									/>
									<button
										onClick={() => handleAddress(false)}
										className='addressCloseButton'
									>
										닫기
									</button>
								</div>
							)}
						</div>
					</div>
					<div className='modal-row alignCenter'>
						<div className='rowValue'>
							<span className='value'>
								<input
									type='text'
									value={OrderData.baseAddress}
									onChange={(e) => handleInputChange(e, 'baseAddress')}
								/>
							</span>
							<span className='value'>
								<input
									type='text'
									value={OrderData.detailedAddress}
									onChange={(e) => handleInputChange(e, 'detailedAddress')}
								/>
							</span>
						</div>
						<button
							onClick={() => handleModify('address')}
							className='addressButton'
						>
							수정
						</button>
					</div>
					<div className='modal-column'>
						<span className='key'>배송메시지</span>
						<span className='value'>
							<input
								type='text'
								value={OrderData.shippingMemo}
								onChange={(e) => handleInputChange(e, 'shippingMemo')}
							/>
							<button onClick={() => handleModify('shippingMemo')}>수정</button>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default OrderInfoModal;
